document.addEventListener('DOMContentLoaded', (event) => {
    const popup = document.querySelector("#brochure-request");
    const items = document.querySelectorAll("#brochure-request .crb__content-item");

    items.forEach(item => {
        const icon = item.querySelector('.icon-wrap');
        
        icon.addEventListener('click', () => {
            items.forEach(each => {
                if (item != each) {
                    each.classList.add('collapsed');        
                }
            });

            item.classList.toggle('collapsed');
        })

        // if (window.innerWidth >= 820 && window.innerWidth < 1280) {
            // const itemTextEle = item.querySelector('.crb-item__text');
            // const itemImageEle = item.querySelector('.crb-item__image');

            // const itemTextHeight = itemTextEle.clientHeight;
            // itemImageEle.style.height = itemTextHeight / 10 + "rem";
        // }
    })

    document.addEventListener('keyup', (event) => {
        if (event.key === "Escape" &&
            window.location.hash &&
            window.location.hash.length > 5) {
            window.location.hash = "#/";
        }
    }, false);

    popup.addEventListener('click', (e) => {
        const popupContent = popup.querySelector('.crb_popup-wrapper');
      
        if (!popupContent.contains(e.target) &&
            window.location.hash &&
            window.location.hash.length > 5) {
            window.location.hash = "#/";
        }
    });
});